import { getBaseUrl } from './getBaseUrl';

/**
 * Remove the customer and instance base slug from a URL.
 * @param slug - URL to strip.
 * @returns the URL without its base slug.
 */
export const removeBaseSlug = (slug: string) => {
    const baseSlug = getBaseUrl(slug);

    return slug.replace(baseSlug, '');
};
